import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle, Home, Phone, AlertTriangle, Clock } from 'lucide-react';
import { ThankYouReferral } from '../components/ThankYouReferral';
import { Reveal } from '../components/motion/Reveal';

const ThankYou = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-[60vh] bg-gradient-to-b from-[#eef6f0] via-[#f8faf7] to-white pt-[104px] md:pt-[160px] pb-10 md:pb-16" data-testid="thankyou-page">
      <div className="max-w-xl mx-auto px-4 text-center">
        <Reveal className="mb-3 md:mb-5 flex justify-center">
          <div className="relative">
            <span className="absolute inset-0 rounded-full bg-[#1a5c3b]/25 animate-ping" />
            <div className="relative w-12 h-12 md:w-20 md:h-20 bg-gradient-to-br from-[#1a5c3b] to-emerald-500 rounded-full flex items-center justify-center shadow-xl shadow-[#1a5c3b]/30">
              <CheckCircle className="w-7 h-7 md:w-11 md:h-11 text-white" />
            </div>
          </div>
        </Reveal>

        <Reveal as="h1" delay={100} className="text-xl sm:text-4xl font-bold text-[#0f172a] leading-tight mb-1 md:mb-3" data-testid="thankyou-title">
          Merci! Votre demande est bien reçue
        </Reveal>
        <Reveal as="p" delay={200} className="text-sm md:text-lg text-slate-600 mb-4 md:mb-6">
          Un expert en financement automobile vous contactera sous peu.
        </Reveal>

        <Reveal delay={300} className="bg-white rounded-2xl border border-amber-200 shadow-sm px-3 py-2.5 md:p-5 mb-3 md:mb-4 text-left flex items-center gap-3" data-testid="thankyou-important">
          <div className="w-7 h-7 md:w-9 md:h-9 rounded-lg md:rounded-xl bg-amber-100 text-amber-600 flex items-center justify-center shrink-0"><AlertTriangle className="w-4 h-4 md:w-5 md:h-5" /></div>
          <p className="md:hidden text-xs text-slate-700"><strong className="text-amber-700">Important :</strong> ne faites aucune autre demande de crédit pendant <strong>48 h</strong>.</p>
          <p className="hidden md:block text-sm text-slate-700 leading-relaxed">
            <strong className="text-amber-700">Important :</strong> pour maximiser vos chances d’approbation, <strong>ne soumettez pas de demande ailleurs</strong> pendant les prochaines <strong>48 heures</strong>. Chaque demande laisse une trace sur votre dossier de crédit.
          </p>
        </Reveal>

        <Reveal delay={400} className="bg-white rounded-2xl border border-emerald-100 shadow-sm px-3 py-2.5 md:p-5 mb-4 md:mb-10 flex items-center gap-3 justify-between">
          <div className="text-left">
            <p className="text-xs md:text-sm text-slate-600">Réponse immédiate :</p>
            <p className="hidden md:flex text-xs text-slate-400 items-center gap-1 mt-0.5"><Clock className="w-3 h-3" />Lun-Jeu 9h-20h · Ven 9h-18h · Sam 10h-16h</p>
          </div>
          <a href="tel:514-418-3968" className="inline-flex items-center justify-center gap-2 bg-[#1a5c3b] hover:bg-[#165432] text-white text-sm md:text-base font-bold px-4 md:px-6 py-2 md:py-3 rounded-full transition-colors" data-testid="thankyou-call">
            <Phone className="w-4 h-4" />514-418-3968
          </a>
        </Reveal>
      </div>

      <div className="max-w-4xl mx-auto px-4 text-center">
        <ThankYouReferral />
        <Link to="/" className="inline-flex items-center gap-2 text-[#1a5c3b] font-semibold hover:underline underline-offset-4" data-testid="thankyou-home">
          <Home className="w-4 h-4" />Retour à l’accueil
        </Link>
      </div>
    </div>
  );
};

export default ThankYou;
